import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { PublicationSettings } from "@/components/PublicationSettings";
import usePublicationSettings from "@/hooks/usePublicationSettings";
import { useSettingsState } from "@/context/SettingsStateContext";
import { useSettings } from "@/context/SettingsContext";
import { useWebsites } from "@/context/WebsitesContext";

export default function PublicationSettingsCard() {
  const { handleSavePublicationSettings } = usePublicationSettings();
  const { postingDays } = useSettingsState();
  const { postingFrequency, weeklyPlanningDay, isAutomatedWeeklyPlanningActive } = useSettings();
  const { currentWebsite } = useWebsites();

  return (
    <Card id="publication">
      <CardHeader>
        <CardTitle>Publication settings</CardTitle>
        <CardDescription>
          Configure your content publication schedule and planning preferences.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          <PublicationSettings
            initialPostingDays={postingDays}
            initialFrequency={postingFrequency}
            initialWeeklyPlanningDay={weeklyPlanningDay}
            initialIsAutomatedWeeklyPlanningActive={isAutomatedWeeklyPlanningActive}
            onSave={handleSavePublicationSettings}
            disabled={!currentWebsite}
          />
        </div>
      </CardContent>
    </Card>
  );
}
